<template>
  <material-card
    v-bind="$attrs"
    class="v-apex-card--material-chart"
    full-header
  >
    <template #heading>
      <div class="px-5">
        <apexchart
          :options="optionsSafe"
          :series="seriesSafe"
          :height="height"
          style="margin: left"
        ></apexchart>
      </div>
    </template>

    <template #subtitle>
      <slot name="subtitle" />
    </template>

    <slot />

    <template #actions>
      <slot name="actions" />
    </template>
  </material-card>
</template>

<script>
export default {
  name: "ApexChartCard",
  inheritAttrs: false,
  props: {
    options: Object,
    series: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      height: 250,
    };
  },
  computed: {
    seriesSafe() {
      if (!this.series || !Array.isArray(this.series) || !this.series.length) {
        return [{ name: "", data: [] }];
      }
      return this.series.map(s => ({
        name: s && s.name != null ? s.name : "",
        data: Array.isArray(s && s.data) ? s.data : []
      }));
    },
    optionsSafe() {
      return this.options || {};
    }
  },
};
</script>

<style lang="sass">
.apexcharts-tooltip
  background: #000
  color: black

.v-apex-card--material-chart
  p
    color: #999

  .v-apex-card--material__sheet
    max-height: 400px
    width: 100%
</style>
